export const STAGE_LAYOUT = {
    TOP: 0,
    BOTTOM: 0,
} as const

export const ISLAND_LAYOUT = {
    TOP: 8,
    HEIGHT: 40,
    CLEARANCE: 56,
} as const

export const SHORTCUT_ICONS_TOP = ISLAND_LAYOUT.CLEARANCE + 12

export const RECORD_STORY_PANEL_LAYOUT = {
    WIDTH: 340,
    OVERLAY_BELOW_WIDTH: 1024,
} as const

export const SHIPMENT_CHAT_PANEL_LAYOUT = {
    WIDTH: 430,
} as const

export const DOCK_LAYOUT = {
    HEIGHT: 80,
} as const

export const PHONE_APP_BAR = {
    HEIGHT: 64,
} as const

export const DESKTOP_Z_INDEX = {
    DESKTOP_ICONS: 10,
    SHELL_BASE: 20,
    SHORTCUTS: 50,
    WINDOWS_BASE: 100,
    SANDBOX_BAR: 9000,
    DOCK: 9998,
    SPOTLIGHT: 10000,
    OVERLAY: 10001,
    TOOLTIP: 10002,
} as const
